<template>
  <div>
    <v-simple-table v-if="statusLogs">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              Role
            </th>
            <th class="text-left">
              Member
            </th>
            <th class="text-left">
              Timestamp
            </th>
            <th class="text-left">
              Status
            </th>
            <th class="text-left">
              comment
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(statusLog, index) in statusLogs" :key="index">
            <td>{{ statusLog.role }}</td>
            <td>{{ statusLog.member.display_name }}</td>
            <td>{{ statusLog.created_at }}</td>
            <td>{{ statusLog.status }}</td>
            <td>{{ statusLog.comment }}</td>
          </tr>

        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "StatusListGrid",

  props: ["statusLogs"],
  components: {},

  data: () => ({
    loading: false,
  }),

  methods: {},
};
</script>
